module.exports = __webpack_public_path__ + "img/dig-arrow.54980f96.svg";